<div class="page-content container">
  <div class="page-header"><h1>{{ translationManager.getTranslation('bob_label_635b9e7f32dbf7514c031f2a') }}</h1></div>
  <div class="page-data shadow-sm">
    <div class="form-blocks">
      <div>
        <div class="content">
          <div class="form-element"><input type="hidden" name="id" [(ngModel)]="form.elements['id'].value"></div>
          <div class="form-element"><input type="hidden" name="requestRoundSupplierId" [(ngModel)]="form.elements['requestRoundSupplierId'].value"></div>
          <div class="page-part">
            <div class="form-element">
              <label>{{translationManager.getTranslation('Датум и време почетка аукције')}}</label>
              <div class="content" *ngIf="true">
                <div class="static"><span>{{ form.elements['auctionStartDate'].value | appdate | appvalue }}</span></div>
              </div>
            </div>
          </div>
          <div class="page-part">
            <div class="form-element">
              <label>{{translationManager.getTranslation('att_label_635b974d32dbf7514c031f18')}}</label>
              <!-- <br>
              <label> auctionDeadline {{auctionDeadline}}</label> -->
              <!-- <br>
              <label> isAuctionEnded {{isAuctionEnded}}</label>
              <br>
              <label> isAuctionStarted {{isAuctionStarted}}</label> -->
              <!-- <br>
              <label> auctionId {{auctionId}}</label>
               -->
              <div class="content">
                <div class="static">
                  <app-timer
                    [auctionDeadline]="auctionDeadline"
                    [auctionEnded]="isAuctionEnded"
                    [auctionStarted]="isAuctionStarted"
                    [selectedAuctionId]="auctionId"
                    (onAuctionEnded)="auctionEnded($event)"
                  ></app-timer>
                </div>
              </div>
            </div>
          </div>
          <div class="page-part">
            <div class="form-element"
                 [ngClass]="{ 'error': form.elements['itemName'].error.required || form.elements['itemName'].error.invalid }">
              <label>{{translationManager.getTranslation('att_label_635b9e8c32dbf7514c031f2c')}}</label>
<!--              <div class="content" *ngIf="false"><input type="text"-->
<!--                                                 [(ngModel)]="form.elements['itemName'].value"/>-->
<!--              </div>-->
              <div class="content" *ngIf="true">
<!--                <div class="static"><span>{{ form.elements["itemName"].value | appvalue }}</span></div>-->
                <div class="static"><span>{{ itemName | appvalue }}</span></div>
              </div>
            </div>
          </div>
          <div class="page-part">
            <div class="form-element"
                 [ngClass]="{'error': form.elements['offeredSupplierAmount'].error.required || form.elements['offeredSupplierAmount'].error.invalid }">
              <label>{{translationManager.getTranslation('Понуђена количина добављача')}}</label>
              <div class="content" *ngIf="true">
                <div class="static"><span>{{ offeredSupplierAmount | appvalue }}</span></div>
              </div>
            </div>
          </div>
          <div class="page-part">
            <div class="form-element"
                 [ngClass]="{'error': form.elements['offeredSupplierPrice'].error.required || form.elements['offeredSupplierPrice'].error.invalid }">
              <label>{{translationManager.getTranslation('Понуђена цена добављача')}}</label>
              <div class="content" *ngIf="true">
                <div class="static"><span>{{ offeredSupplierPrice | number : '1.2-2':'sr' | appvalue }}</span></div>
              </div>
            </div>
          </div>
          <div class="page-part">
            <div class="form-element">
              <label>{{translationManager.getTranslation('att_label_635b9eb032dbf7514c031f2d')}}</label>
              <div class="content" *ngIf="true">
                <div class="static"><span>{{ form.elements['offeredAmount'].value | appvalue }}</span></div>
              </div>
            </div>
          </div>
<!--          <div class="page-part">-->
<!--            <div class="form-element"-->
<!--                 [ngClass]="{ 'error':-->
<!--                      form.elements['offeredAmount'].state.dirty &&-->
<!--                      ((form.elements['offeredAmount'].error.required && form.elements['offeredAmount'].value !== 0) ||-->
<!--                      form.elements['offeredAmount'].error['equalsZeroError'] ||-->
<!--                      form.elements['offeredAmount'].error.invalid) }">-->
<!--              <label>{{translationManager.getTranslation('att_label_635b9eb032dbf7514c031f2d')}}</label>-->
<!--              <div class="content" *ngIf="state === viewState.Create || state === viewState.Edit">-->
<!--                <input type="text"-->
<!--                       [(ngModel)]="form.elements['offeredAmount'].value"-->
<!--                       [InputOnlyNumber]="true" name="offeredAmount"-->
<!--                       (keyup)="onFormInput('offeredAmount')"-->
<!--                       (paste)="onFormInput('offeredAmount')"-->
<!--                />-->
<!--                <div class="errors">-->
<!--                      <span *ngIf="form.elements['offeredAmount'].state.dirty && form.elements['offeredAmount'].error.required && form.elements['offeredAmount'].value !== 0">-->
<!--                        <i class="fas fa-times-circle"></i>{{ translationManager.getTranslation('Поље је обавезно за унос') }}-->
<!--                      </span>-->
<!--                      <span *ngIf="form.elements['offeredAmount'].state.dirty && form.elements['offeredAmount'].error['equalsZeroError']">-->
<!--                        <i class="fas fa-times-circle"></i>{{ 'Вредност не сме бити једнака нули' }}-->
<!--&lt;!&ndash;                        <i class="fas fa-times-circle"></i>{{ translationManager.getTranslation('Поље је обавезно за унос') }}&ndash;&gt;-->
<!--                      </span>-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="content" *ngIf="state === viewState.Details">-->
<!--                <div class="static"><span>{{ form.elements["offeredAmount"].value | appvalue }}</span></div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
          <div class="page-part">
            <div class="form-element"
                 [ngClass]="{ 'error': form.elements['offeredPrice'].state.dirty &&
                 (form.elements['offeredPrice'].error['bigPriceError'] ||
                 form.elements['offeredPrice'].error['equalsZeroError'] ||
                 (form.elements['offeredPrice'].error.required && form.elements['offeredPrice'].value !== 0) ||
                 form.elements['offeredPrice'].error.invalid) }">
              <!-- <label>{{translationManager.getTranslation('att_label_635b9ecf32dbf7514c031f2e')}}</label>  derrad 15.05.2023--> 
              <label>{{translationManager.getTranslation('Понуђена јединична цена')}}</label>
              <div class="content" *ngIf="state === viewState.Create || state === viewState.Edit">
                <input type="text" name="offeredPrice"
                       [(ngModel)]="form.elements['offeredPrice'].value"
                       currencyMask
                       (keyup)="onFormInput('offeredPrice')"
                       (paste)="onFormInput('offeredPrice')"
                       (blur)="onFormInput('offeredPrice')"
                       [options]="{ prefix: '', thousands: '.', decimal: ',', align: 'left', precision: 2}"
                />
                <div class="errors">
                      <span *ngIf="form.elements['offeredPrice'].state.dirty && form.elements['offeredPrice'].error.required && form.elements['offeredPrice'].value !== 0">
                        <i class="fas fa-times-circle"></i>{{ translationManager.getTranslation('Поље је обавезно за унос') }}
                      </span>
                      <span *ngIf="form.elements['offeredPrice'].state.dirty && form.elements['offeredPrice'].error['bigPriceError']">
<!--                        <i class="fas fa-times-circle"></i>{{ 'Понуђена цена не сме бити већа од цене у понуди и претходно унете цене' }}-->
                        <i class="fas fa-times-circle"></i>{{ translationManager.getTranslation('Понуђена цена не сме бити већа од цене у понуди и претходно унете цене') }}
                      </span>
                      <span *ngIf="form.elements['offeredPrice'].state.dirty && form.elements['offeredPrice'].error['equalsZeroError']">
<!--                        <i class="fas fa-times-circle"></i>{{ 'Вредност не сме бити једнака нули' }}-->
                        <i class="fas fa-times-circle"></i>{{ translationManager.getTranslation('Вредност не сме бити једнака нули') }}
                      </span>
                </div>
              </div>
              <div class="content" *ngIf="state === viewState.Details">
                <div class="static"><span>{{ form.elements["offeredPrice"].value | number : '1.2-2':'sr' | appvalue }}</span></div>
              </div>
            </div>
          </div>
          <translation-entity *ngIf="translationEntityDisplay" #translationEntitySupplierAuctionOfferListViewName
                              [uniqueIdentifier]="'SupplierAuctionOfferListView-Name'"></translation-entity>
          <div class="form-element-buttons">
            <button class="btn btn-warning fl" (click)="navigateToList()">
              <i class="fa fa-arrow-left mr-2"></i>{{ translationManager.getTranslation('Назад') }}</button>
            <button class="btn btn-success fr" (click)="checkSubmit()" [disabled]="
                !form.isValid() || isAuctionEnded || !isAuctionStarted ||
                form.elements['offeredPrice'].error.bigPriceError || form.elements['offeredPrice'].error.equalsZeroError
            "
                    *ngIf="state === viewState.Create || state === viewState.Edit">
              <i class="fa fa-check mr-2"></i>{{ translationManager.getTranslation('Сачувај') }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<app-modal [show]="displaySubmitModal" [title]="translationManager.getTranslation('Сачувај')">
  <div class="app-modal-content">
    <label>{{ translationManager.getTranslation('Да ли сте сигурни да желите да промените понуђену цену?') }}</label></div>
  <div class="app-modal-actions">
    <button class="btn btn-success" (click)="submit()"><i
      class="fa fa-check mr-2"></i>{{ translationManager.getTranslation('Да') }}</button>
    <button (click)="displaySubmitModal = false" class="btn btn-warning"><i
      class="fa fa-times mr-2"></i>{{ translationManager.getTranslation('Не') }}</button>
  </div>
</app-modal>
